import { useContext } from "react";
import { LanguagesContext } from "./LanguageContext";

export const useLanguages = () => useContext(LanguagesContext);
